import React from 'react';
import { ReactChat } from '@smarterservices/react-chat';
import {
  getStore,
  usePlayerStore,
  useExamSessionStore,
} from '../../../stores/StoreContext';
import { formatTime } from '../../../helpers/utilities';
import { useEffect, useRef, useState } from 'react';

const Chat = () => {
  const AppStore = getStore('appStore');

  const isLive = usePlayerStore((state) => state.isLive);
  const currentTime = usePlayerStore((state) => state.currentTime);
  const recordingStartDate = useExamSessionStore(
    (state) => state.sessionData.recordingStartDate
  );
  const canHaveLiveVideo = usePlayerStore((state) => state.canHaveLiveVideo);

  const chatRef = useRef(null);

  const [, setHighlightedMessageTime] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      chatRef.current.scrollToBottom(true);
    }, 1000);
  }, []);

  useEffect(() => {
    if (!isLive) {
      const hasMatch =
        chatRef.current.scrollToMessageBySessionTime(currentTime);
      if (hasMatch) {
        setHighlightedMessageTime(currentTime);
      }
    }
  }, [currentTime]);

  return (
    <>
      <ReactChat
        ref={(el) => (chatRef.current = el)}
        roomId={AppStore.roomId}
        identity={AppStore.identity}
        token={AppStore.spToken}
        referenceId={AppStore.roomId}
        apiUrl={AppStore.apiUrl}
        websocketUrl={AppStore.websocketUrl}
        startTime={recordingStartDate}
        allowNewMessage={!canHaveLiveVideo}
        renderSessionTime={(seconds, message) => {
          return formatTime(seconds);
        }}
        displayName="Jason"
      />
    </>
  );
};

export default Chat;
